import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _possibleConstructorReturn from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _inherits from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import BaseModel from "./BaseModel";
var CustomerEmail = /*#__PURE__*/function (_BaseModel) {
  function CustomerEmail(props) {
    var _this;
    _classCallCheck(this, CustomerEmail);
    _this = _callSuper(this, CustomerEmail, [props]);
    _this._types = {
      1: 'Home',
      2: 'Work',
      3: 'Other'
    };
    return _this;
  }
  _inherits(CustomerEmail, _BaseModel);
  return _createClass(CustomerEmail, [{
    key: "type",
    value: function type() {
      return this._types[this.get('email_type_id')];
    }
  }, {
    key: "isDefault",
    value: function isDefault() {
      return this.get('is_default');
    }
  }]);
}(BaseModel);
export default CustomerEmail;